import { useCreateTeamMember } from "../api/useCreateTeamMember"
import { useDeleteTeamMember } from "../api/useDeleteTeamMember"
import { useUpdateTeamMember } from "../api/useUpdateTeamMember"

export function useTeamMemberMutations() {
  const { createTeamMember, createMultipleTeamMembers } = useCreateTeamMember()
  const { updateTeamMember } = useUpdateTeamMember()
  const { deleteTeamMember } = useDeleteTeamMember()

  return {
    createTeamMember,
    createMultipleTeamMembers,
    updateTeamMember,
    deleteTeamMember
  }
}
